import { render, staticRenderFns } from "./report_stu_zhushou.vue?vue&type=template&id=90a82244&scoped=true&"
import script from "./report_stu_zhushou.vue?vue&type=script&lang=js&"
export * from "./report_stu_zhushou.vue?vue&type=script&lang=js&"
import style0 from "./report_stu_zhushou.vue?vue&type=style&index=0&id=90a82244&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a82244",
  null
  
)

export default component.exports